import { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./SchoolReportStudentsUIHelpers";

const SchoolReportStudentsUIContext = createContext();

export function useSchoolReportStudentsUIContext() {
  return useContext(SchoolReportStudentsUIContext);
}

export const SchoolReportStudentsUIConsumer = SchoolReportStudentsUIContext.Consumer;

export function SchoolReportStudentsUIProvider({ term, children }) {
  initialFilter.term = term; // Dönem Atanıyor
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    term,
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams
  };

  return (
    <SchoolReportStudentsUIContext.Provider value={value}>
      {children}
    </SchoolReportStudentsUIContext.Provider>
  );
}